/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaptureLabelSchema } from './CaptureLabelSchema';
import {
    CaptureLabelSchemaFromJSON,
    CaptureLabelSchemaFromJSONTyped,
    CaptureLabelSchemaToJSON,
    CaptureLabelSchemaToJSONTyped,
} from './CaptureLabelSchema';

/**
 * 
 * @export
 * @interface ListCaptureLabelsResponse
 */
export interface ListCaptureLabelsResponse {
    /**
     * 
     */
    labels: Array<CaptureLabelSchema>;
}

/**
 * Check if a given object implements the ListCaptureLabelsResponse interface.
 */
export function instanceOfListCaptureLabelsResponse(value: object): value is ListCaptureLabelsResponse {
    if (!('labels' in value) || value['labels'] === undefined) return false;
    return true;
}

export function ListCaptureLabelsResponseFromJSON(json: any): ListCaptureLabelsResponse {
    return ListCaptureLabelsResponseFromJSONTyped(json, false);
}

export function ListCaptureLabelsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListCaptureLabelsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'labels': ((json['labels'] as Array<any>).map(CaptureLabelSchemaFromJSON)),
    };
}

export function ListCaptureLabelsResponseToJSON(json: any): ListCaptureLabelsResponse {
    return ListCaptureLabelsResponseToJSONTyped(json, false);
}

export function ListCaptureLabelsResponseToJSONTyped(value?: ListCaptureLabelsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'labels': ((value['labels'] as Array<any>).map(CaptureLabelSchemaToJSON)),
    };
}

